var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 輔翼會員 查詢 ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("輔翼會員 查詢")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "電話"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "placeholder": "請輸入手機號碼"
    },
    model: {
      value: _vm.phone,
      callback: function callback($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "會員代號(MemberCode)"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "placeholder": "請輸入會員代號"
    },
    model: {
      value: _vm.memberCode,
      callback: function callback($$v) {
        _vm.memberCode = $$v;
      },
      expression: "memberCode"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "會員唯一號(MemberSerNo)"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "placeholder": "請輸入會員唯一號"
    },
    model: {
      value: _vm.memberSerNo,
      callback: function callback($$v) {
        _vm.memberSerNo = $$v;
      },
      expression: "memberSerNo"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 會員類別唯一碼 "), _c('i', {
          staticClass: "mdi mdi-help-circle-outline",
          attrs: {
            "id": "flaps-member-class-ser-no-tooltip"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "flaps-member-class-ser-no-tooltip",
            "triggers": "hover",
            "placement": "right"
          }
        }, [_vm._v(" 使用電話或會員代號查詢時，會員類別唯一碼為必填；僅以會員唯一號查詢時可選填。 ")])];
      },
      proxy: true
    }])
  }, [_c('b-input-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "placeholder": "請輸入會員類別唯一碼"
    },
    model: {
      value: _vm.memberClassSerNo,
      callback: function callback($$v) {
        _vm.memberClassSerNo = $$v;
      },
      expression: "memberClassSerNo"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v(" 查詢 ")])], 1), _c('editor', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "width": "100%",
      "height": "300px",
      "lang": "json",
      "theme": "chrome",
      "disabled": !_vm.editable
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.result,
      callback: function callback($$v) {
        _vm.result = $$v;
      },
      expression: "result"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }